const renderTemplateWithData = (
  template: string,
  values: Record<string, string>
) => {
  let compiledTemplate = template;

  Object.entries(values).forEach(([key, value]) => {
    compiledTemplate = compiledTemplate.replaceAll(`{${key}}`, value);
  });

  return compiledTemplate;
};

export default renderTemplateWithData;
